import { Bolt, ChatOutline1, ChatOutline2, ChatRound, ChatSquare } from 'components/lib/icons'
import React from 'react'
import { useSelector } from 'react-redux'
import { EmbedTheme } from 'types/embed'

const useThemeIcon = () => {
  const { theme }: { theme: EmbedTheme } = useSelector(state => state.embed.configuration)
  const { iconStyle, iconUrl, foregroundColor } = theme

  const ICON_TYPE_TO_COMPONENT = {
    SOLID1: <ChatSquare fill={`#${foregroundColor}`}/>,
    SOLID2: <ChatRound fill={`#${foregroundColor}`}/>,
    OUTLINE1: <ChatOutline1 fill={`#${foregroundColor}`}/>,
    OUTLINE2: <ChatOutline2 fill={`#${foregroundColor}`}/>,
    BOLT: Bolt
  }

  const customIcon = iconUrl
    ? {
      backgroundImage: `url(${iconUrl})`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat'
    }
    : {}

  return {
    customIcon,
    hasCustomIcon: !!iconUrl,
    Icon: ICON_TYPE_TO_COMPONENT[iconStyle] || null
  }
}

export default useThemeIcon
